import React, { Component } from 'react';
import animations from './animations';

class BackToTop extends Component {

    componentDidMount() {
        animations.initialise();
    }

    backToTop(event) {
        event.preventDefault();
        animations.backToTop();
    }

    render () {
        return (
            <a
                href="#"
                id="back-to-top"
                className="back-to-top"
                onClick={this.backToTop.bind(this)}
            >
                <img src="/images/icon-back-to-top.svg" alt="top..." />
            </a>
        );
    }

}

export default BackToTop;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/BackToTop/BackToTop.js